import {RenderingServices } from '@wallaby-ui/core';
import {MerieSchema} from 'src/js/common/types';
import {TemplatedCellRendererParams} from 'src/js/containers/grid/grid_types';

import {I18N} from './base_link_formatter_params';


type Params = TemplatedCellRendererParams<
  MerieSchema.components['schemas']['EvaluatedEncounterDto']
>;

export interface BaseHospitalizationsListLinkFormatterParamsReturnValue {
  id: string | number;
  /** @deprecated remove .label */
  label: string | undefined;
  titleText: string | number;
  versionSuffix?: string;
}

export function baseHospitalizationsListLinkFormatterParams(
  params: Params,
  services: RenderingServices = {}
): BaseHospitalizationsListLinkFormatterParamsReturnValue {
  const {intl} = services;
  const {data, value} = params;
  const label = `${value}`;

  const {id} = data;

  const titleText = `${intl?.formatMessage(I18N.OPEN_DETAIL)} - ${label}`;

  return {...params, label, id, titleText};
}
